export default "__VITE_ASSET__1601b297__"